<template>
  <auth-page>
    <div slot="content">
      <div class="form">
        <h2 class="title is-3">Wat doe jij dit jaar?</h2>
        <p>Werk je opleiding bij om te beginnen met leren</p>
        <br />
        <b-field label="Leerjaar">
          <b-select v-model="user.year" size="is-medium" placeholder="Selecteer je jaar" expanded="expanded">
            <option v-for="n in 10" :value="n" :key="n">{{ n }}</option>
            <option value="anders">Anders</option>
          </b-select>
        </b-field>
        <b-field label="Opleiding">
          <b-select v-model="user.level" size="is-medium" placeholder="Selecteer je opleiding" expanded="expanded">
            <option v-for="level in educationLevels" :value="level" :key="level">{{ level | capitalize }}</option>
            <option value="anders">Anders</option>
          </b-select>
        </b-field>
        <b-field>
          <b-button @click="saveEducation()" type="is-info" expanded>Bijwerken</b-button>
        </b-field>
      </div>
    </div>
  </auth-page>
</template>
<script>
import ApiService from "@/common/api.service"
import AuthPage from "../components/AuthPage.vue"

export default {
  components: { AuthPage },
  data() {
    return {
      user: {
        year: this.$store.state.user.year + 1,
        level: this.$store.state.user.level,
      },
    }
  },
  mounted() {
    console.log(this.$store.state.user.year)
  },
  methods: {
    async saveEducation() {
      await ApiService.post("user/update", { year: this.user.year, level: this.user.level })

      this.$gtag.event("change_education", { event_category: "user", value: 1 })

      this.$buefy.toast.open({
        message: "Je opleidingsinstellingen zijn aangepast",
        type: "is-success",
      })

      return window.location.href = "https://woordjes.ikleeralles.nl"
    },
  },
  computed: {
    educationLevels() {
      return this.$store.state.app.educationLevels
    },
  },
}
</script>
<style lang="scss">
.half-illustration {
  background: #fff !important;
}
.title.is-3 {
  margin-bottom: 5px;
}
.button {
  margin-top: 20px;
}
</style>